<template>
    <div class="previewContainer" :style="container">
      <div style="display:flex; flex-direction: column">
        <p class="previewText textCustom" ref="previewText" :style="text" v-html="previewText"></p>
        <p class="previewText textCustom" ref="previewText2" :style="text" v-html="previewText2"></p>
      </div>
    </div>
</template>

<script>
export default {
  props: ['inputText', 'inputText2', 'previewOptions', 'previewVertOffset'],
  data() {
    return {
      // originalFontSize: this.previewOptions.originalFontSize,
      // previewHeight: this.previewOptions.previewHeight,
      // // previewVertOffset: this.previewOptions.previewVertOffset,
      // safeWidth: this.previewOptions.safeWidth,

      container: {
        height: 0,
      },
      text: {
        fontSize: '90px',
        // position: 'absolute',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // top: 0,
        // right: 0,
        color: 'white',
        textShadow: '1px 2px 4px rgba(0, 0, 0, 0.75)',
      },

      previewHeightFirst: 420,
    };
  },

  computed: {
    originalFontSize() {
      return this.previewOptions.originalFontSize;
    },
    previewHeight() {
      return this.previewOptions.previewHeight;
    },
    safeWidth() {
      return this.previewOptions.safeWidth;
    },
    previewText() {
      return this.nl2br(this.htmlEntities(this.inputText));
    },
    previewText2() {
      return this.nl2br(this.htmlEntities(this.inputText2));
    },
    newHeight() {
      if (this.inputText === '') { return 0; }
      if (this.previewHeightFirst === 420) { return 140; } if (this.previewHeightFirst === 300) { return 100; } if (this.previewHeightFirst === 240) { return 80; } if (this.previewHeightFirst === 180) { return 60; } if (this.previewHeightFirst === 120) { return 40; } return 20;
    },
  },

  mounted() {
    requestAnimationFrame(this.render);
  },

  methods: {
    render() {
      this.keepRatio();
      this.scaleText();
      requestAnimationFrame(this.render);
    },

    /**
     * Maintain the aspect ratio of the container
     */
    keepRatio() {
      // const { newHeight } = this;// Math.round(this.$el.clientWidth * (9 / 16))
      // this.previewHeight = newHeight;
      // this.container.height = `${newHeight}px`;
    },

    /**
     * Scale the previewText element to fit the previewContainer
     */
    scaleText() {
      let newFontSize = 0;
      let newTextScale = 1;
      const previewScale = this.previewHeight / this.previewHeightFirst;
      // console.log('previewScale = '+previewScale)

      // If the current text does not fit inside the "safeWidth" bounds of the default container, scale it
      const currentTextWidth = this.textWidth();

      if (currentTextWidth > this.safeWidth) {
        newTextScale = this.safeWidth / currentTextWidth;
      }

      // Scale text to match the actual container size
      newTextScale *= previewScale;

      newFontSize = parseInt(this.text.fontSize, 10) * newTextScale;

      this.updateTextSize(newFontSize);
    },

    /**
     * Update the font size and position of the text element in the DOM
     */
    updateTextSize(newFontSize) {
      this.$refs.previewText.style['font-size'] = `${newFontSize}px`;
      this.$refs.previewText2.style['font-size'] = `${newFontSize}px`;
      this.text.fontSize = `${newFontSize}px`;

      // const size = this.getElementSizes();
      // this.text.right = `${0}px`;// (size.container.width - size.text.width) / 2 + 'px'
      // this.text.top = `${(size.container.height - size.text.height) / 2 + (this.previewVertOffset * previewScale)}px`;
    },

    /**
     * Get the full width of the previewText element
     */
    textWidth() {
      this.text.fontSize = `${this.originalFontSize}px`;
      this.$refs.previewText.style['font-size'] = `${this.originalFontSize}px`;
      this.$refs.previewText.style.overflow = 'auto';

      this.$refs.previewText2.style['font-size'] = `${this.originalFontSize}px`;
      this.$refs.previewText2.style.overflow = 'auto';

      const textWidth = this.$refs.previewText.scrollWidth;

      // this.$refs.previewText.style.overflow = 'hidden';
      return textWidth;
    },

    /**
     * Get the total height and width for the container and text elements
     */
    getElementSizes() {
      return {
        container: {
          width: this.$el.getBoundingClientRect().width,
          height: this.$el.getBoundingClientRect().height,
        },
        text: {
          width: this.$refs.previewText.getBoundingClientRect().width,
          height: this.$refs.previewText.getBoundingClientRect().height,
        },
        text2: {
          width: this.$refs.previewText2.getBoundingClientRect().width,
          height: this.$refs.previewText2.getBoundingClientRect().height,
        },
      };
    },

    htmlEntities(str) {
      return String(str).replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>')
        .replace(/"/g, '"');
    },

    nl2br(string) {
      return string.replace(/(\r\n|\n\r|\r|\n)/g, '<br>');
    },
  },
};
</script>

<style lang="scss" scoped>
.previewContainer {
  width: 100%;
  height: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.textCustom {
  line-height: 1.5;

  &:first-child {
    padding-bottom: unset;
  }

  &:last-child {
    padding-top: unset;
  }
}
</style>
